export default [
  {
    type: 1,
    name: "RelayBox06Channel",
    prefix: '6ch',
    outputs: 6,
    img_path: "/assets/img/app-icons/UQ.png",
  },
  {
    type: 2,
    name: "RelayBox12Channel",
    prefix: '12ch',
    outputs: 12,
    img_path: "/assets/img/app-icons/7c1.png",
  },
  {
    type: 3,
    name: "UniversalRemote",
    prefix: 'UR',
    outputs: 1,
    img_path: "/assets/img/app-icons/je.png",
  },
  {
    type: 4,
    name: "Dimmer",
    prefix: 'DIM',
    outputs: 2,
    img_path: "/assets/img/app-icons/gD.png",
  },
  {
    type: 5,
    name: "Thermostat",
    prefix: 'TRM',
    outputs: 5,
    img_path: "/assets/img/app-icons/t05.png",
  },
  {
    type: 7,
    name: "RelayBox12Channel_Black_1",
    prefix: '12ch',
    outputs: 12,
    img_path: "/assets/img/app-icons/wp.png",
  },
  {
    type: 8,
    name: "RelayBox12Channel_Black_2",
    prefix: '12ch',
    outputs: 12,
    img_path: "/assets/img/app-icons/aw.png",
  },
  {
    type: 9,
    name: "RGB",
    prefix: 'RGB',
    outputs: 6,
    img_path: "/assets/img/app-icons/gD.png",
  },
  {
    type: 10,
    name: "RelayBox12Channel_Black_3",
    prefix: '12ch',
    outputs: 12,
    img_path: "/assets/img/app-icons/Kw.png",
  },
  {
    type: 11,
    name: "RelayBox01Channel",
    prefix: '1ch',
    outputs: 1,
    img_path: "/assets/img/app-icons/89.png",
  },
  {
    type: 12,
    name: "RelayBox12Channel_GSM",
    prefix: 'G12ch',
    outputs: 12,
    img_path: "/assets/img/app-icons/Kw.png",
  },
  {
    type: 13,
    name: "RelayBox02Channel",
    prefix: '2ch',
    outputs: 2,
    img_path: "/assets/img/app-icons/Uk.png",
  },
  {
    type: 14,
    name: "RelayBox03Channel",
    prefix: '3ch',
    outputs: 3,
    img_path: "/assets/img/app-icons/UR.png",
  },
  {
    type: 15,
    name: "RelayBox04Channel",
    prefix: '4ch',
    outputs: 4,
    img_path: "/assets/img/app-icons/UO.png",
  },
  {
    type: 16,
    name: 'DataLogger',
    prefix: 'DATA',
    outputs: 1,
    img_path: "/assets/img/app-icons/5.png",
  }
];
